export default "<p>dw-image-zoom-modal works!</p>\r\n\r\n<!-- <img [src]=\"src\" [defaultSrc]=\"defaultSrc\" [ngStyle]=\"imageStyle\" [ngClass]=\"class\"> -->";